<template>
  <div class="image-field-wrapper d-flex align-items-center flex-column">
    <b-form-file
      v-if="!field.info"
      class="w-100"
      :ref="field.key"
      :id="field.key"
      @change="handleFileUpload($event, field)"
      :accept="accept"
      :browse-text="browseText"
      :placeholder="placeholder"
    />
    <viewer
      v-else
      class="w-100 ml-1"
      :images="[field.info.src]"
    >
      <div class="d-flex align-items-center mr-2 justify-content-center mt-1">
        <b-img
          :src="field.info.src"
          v-bind="imageProps"
          class="image"
          :class="field.icon ? 'icon' : 'w-50'"
          title="Просмотр изображения"
        />
        <div
          title="Изменить изображение"
          @click="changeImage(field)"
        >
          <feather-icon
            class="mx-50 cursor-pointer"
            icon="XSquareIcon"
            size="24"
          />
        </div>
      </div>
    </viewer>
  </div>
</template>

<script>

import {
  BFormFile, BImg
} from 'bootstrap-vue'
import { showWarningOperationToast } from '@/composables/toast'

export default {
  name: 'ImageField',
  components: {
    BFormFile, BImg
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      imageProps: {},
    }
  },
  computed: {
    accept() {
      return this.field.imageExtensions ? this.field.imageExtensions.map(format => `.${format}`).join(', ') : 'image/*'
    },
    browseText() {
      return this.field.browseText ? this.field.browseText : 'Выбрать'
    },
    placeholder() {
      let text = 'Изображение'
      if (this.field.placeholder) {
        text = this.field.placeholder
      }
      if (this.field.placeholderWithExt && this.field.imageExtensions && this.field.imageExtensions.length) {
        text = `${text} (${this.field.imageExtensions.map(format => `.${format}`).join(', ')})`
      }
      return text
    },
  },
  methods: {
    handleFileUpload(event, field) {
      if (event.target.files.length && this.field.imageExtensions && this.field.imageExtensions.length) {
        const file = event.target.files[0]
        if (this.imageIsValid(file, field)) {
          const reader = new FileReader();
          reader.onload = e => {
            field.info = {name: file.name, src: e.target.result}
            this.formData[field.key] = file
            this.$forceUpdate()
            this.emitUpdateFormData(field)
          }
          reader.readAsDataURL(file)
        }
      } else {
        this.formData[field.key] = event.target.files.length ? event.target.files[0] : null
        this.emitUpdateFormData(field)
      }
    },
    imageIsValid(file, field) {
      let imageType = file.type.split('/')
      imageType = imageType.length === 2 ? imageType[1] : null
      if (this.field.icon && file.size > 20000) {
        this.$refs[field.key].$el.getElementsByClassName('form-file-text')[0].innerText = this.placeholder
        this.changeImage(field)
        showWarningOperationToast(
          'Размер изображения не должен превышать 20кБ! Пожалуйста, произведите выбор повторно.'
        )
        return false
      }
      if (!this.field.imageExtensions.includes(imageType)) {
        this.$refs[field.key].$el.getElementsByClassName('form-file-text')[0].innerText = this.placeholder
        this.changeImage(field)
        showWarningOperationToast('Выбран неверный формат изображения! Пожалуйста, произведите выбор повторно.')
        return false
      }
      return true
    },
    changeImage(field) {
      field.info = null
      this.formData[field.key] = null
      this.emitUpdateFormData(field)
      this.$forceUpdate()
    },
    emitUpdateFormData(field) {
      this.$emit('updateFormData', {'formData': this.formData, 'field': field})
    }
  }
}
</script>

<style lang='scss'></style>
